import { connect } from 'react-redux';
import { createSubmitAction } from '../../../../app/forms';
import { FormattedMessage } from 'react-intl';
import { getAddressbooks, selectAddressbooks } from '../../../../addressbook/addressbooks';
import { getOrder, updateOrder } from '../../../order';
import { getStep, nextStep } from '../../../steps';
import { selectRegions } from '../../../../app/regions';
import CreateAddressForm from '../../../../addressbook/forms/CreateAddress';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/Form.scss';

import {
    CREATE_LOCATION_SUBMIT,
    CREATE_LOCATION_SUCCESS,
    CREATE_LOCATION_FAILURE,
} from '../../../../addressbook/locations';

export class ShippingFormStep extends Component {
    static propTypes = {
        addressbooks: ImmutablePropTypes.map,
        dispatch: PropTypes.func.isRequired,
        order: ImmutablePropTypes.map.isRequired,
        regions: ImmutablePropTypes.map,
        step: ImmutablePropTypes.map.isRequired,
    }

    componentWillMount() {
        this.props.dispatch(getAddressbooks());
    }

    handleSubmitFailure = () => {
        window.scrollTo(0, 0);
    };

    handleSubmitSuccess = (location) => {
        const { order, dispatch, step } = this.props;
        const newOrder = order.set('location', location.get('id'));

        dispatch(updateOrder(newOrder));
        dispatch(nextStep(step));
    }


    render() {
        const { addressbooks, regions, order, dispatch } = this.props;
        const shipToNewAddress = order.get('shipToNewAddress');
        const initialValues = Immutable.fromJS({
            address: { region: order.get('region') },
        });

        const submitter = createSubmitAction(
            CREATE_LOCATION_SUBMIT,
            CREATE_LOCATION_SUCCESS,
            CREATE_LOCATION_FAILURE
        );
        if (shipToNewAddress) {
            return (
                <div className={styles.container}>
                    <h2>
                        <FormattedMessage id='frontend.form_selector_shipping.headline.create' />
                    </h2>
                    <CreateAddressForm.Component
                        addressbooks={addressbooks}
                        initialValues={initialValues}
                        onSubmit={submitter}
                        onSubmitSuccess={this.handleSubmitSuccess}
                        onSubmitFail={this.handleSubmitFailure}
                        regions={regions}
                        order={order}
                        dispatch={dispatch}
                    />
                </div>
            );
        }
        else {
            return null;
        }


    }
}

export default connect(state => ({
    addressbooks: selectAddressbooks(state),
    order: getOrder(state),
    regions: selectRegions(state),
    step: getStep(state, 'shipping'),
}))(ShippingFormStep);
